/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseInput } from '@/Helpers/Components/DataForm/BaseInput'

/**************************************************************************************************/
/** @export Class @name InputPassword                                                            **/
/**************************************************************************************************/
export class InputPassword extends BaseInput
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private visibility: boolean

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string)
	{
		super()
		this.Key        = key
		this.Label      = label
		this.Visibility = false
		this.setParamsType('password')
		this.setParamsState(super.resolveInputState)
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Visibility() : boolean
	{
		return this.visibility
	}

	public set Visibility(value)
	{
		this.visibility = value
	}
}